<div class="side-bar__ctn" [class.minimised]="!fullSidebar">
  <div class="left-navigation-logo">
    <a routerLink="/">
      <img [src]="logo" class="logo-shiva" [class.d-none]="fullSidebar" alt="Logo">
      <img [src]='logoInline' class="logo-shiva" [class.d-none]="!fullSidebar" alt="Logo" [title]="VERSION">
    </a>
  </div>
  <div class="left-navigation-menu">
    <ul class="list-menu">
      @for (route of routes; track route) {
        <li [class]="route.route">
          <a [routerLink]="'/' + route.route" [queryParams]="route.params" [routerLinkActive]="['active']">
            <i [class]="route.icon + ' menu-icon'"></i>
            <span class="item-menu text-menu" [translate]="route.name"></span>
          </a>
        </li>
      }

      @if (autAppGuard !== NotAuthenticatedJustLoggedIn) {
        <li class="logout">
          <a href="javascript:void(0)" (click)="logout()">
            <i [class]="iconClass.LOG_OUT + ' menu-icon'"></i>
            <span class="item-menu text-menu" [translate]="'menu.logout'"></span>
          </a>
        </li>
      }
    </ul>
  </div>

  @if (autAppGuard !== NotAuthenticatedJustLoggedIn) {
    <div class="left-navigation-second">
      <i class="fas fa-user-circle menu-icon-profile"></i>
      <span class="item-menu">{{userName}}</span>
    </div>
  }
</div>
